/**
 * 活动时间配置（北京时间）
 * 与 useActivityCheck、营销模块、618 弹窗倒计时共用。
 */
export const ACTIVITY_TIME_CONFIG = {
  start: "2026-06-16 00:00:00",
  end: "2026-06-30 23:59:59"
} as const;
